import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { useCliente } from "../context/ClienteContext";

const ListagemCursos = () => {
  const [cursos, setCursos] = useState([]);
  const [coordenadores, setCoordenadores] = useState([]);

  const [filtros, setFiltros] = useState({
    codigo: "",
    nome: "",
    nivel: "",
    modalidade: "",
    coordenador: ""
  });

  const { parametros } = useCliente();
  const clienteId = localStorage.getItem("cliente_id");
  const tipoUsuario = localStorage.getItem("tipo");

  const buscarCursos = (filtrosAplicados = filtros) => {
    const tipo = localStorage.getItem("tipo");
    const userId = localStorage.getItem("user_id");
    const clienteId = localStorage.getItem("cliente_id");

    if (!userId || !clienteId || !tipo) {
      console.warn("Dados ausentes para consulta de cursos:", {
        userId,
        clienteId,
        tipo
      });
      alert("Erro ao buscar cursos: dados de sessão ausentes.");
      return;
    }

    const params = {
      cliente_id: clienteId,
      tipo: tipo,
      user_id: userId,
      ...filtrosAplicados
    };

    axios
      .get("http://localhost:5000/api/cursos", { params })
      .then((res) => setCursos(res.data))
      .catch((err) => {
        console.error("Erro ao buscar cursos:", err);
        alert("Erro ao buscar cursos");
      });
  };

  useEffect(() => {
    axios
      .get(`http://localhost:5000/api/usuarios/coordenadores?cliente_id=${clienteId}`)
      .then((res) => setCoordenadores(res.data))
      .catch(() => alert("Erro ao carregar coordenadores."));

    buscarCursos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clienteId]);

  const handleChange = (e) => {
    const novosFiltros = { ...filtros, [e.target.name]: e.target.value };
    setFiltros(novosFiltros);
    buscarCursos(novosFiltros);
  };

  const handleLimpar = () => {
    const filtrosZerados = {
      codigo: "",
      nome: "",
      nivel: "",
      modalidade: "",
      coordenador: ""
    };
    setFiltros(filtrosZerados);
    buscarCursos(filtrosZerados);
  };

  return (
    <div className="form-wrapper">
      <h2 className="form-title">
        {["coordenador", "professor"].includes(tipoUsuario) ? "Meus Cursos" : "Cursos Cadastrados"}
      </h2>

      <div className="filtros-cursos">
        <div className="filtros-linha-1">
          <input
            type="text"
            name="codigo"
            placeholder="Filtrar código"
            value={filtros.codigo}
            onChange={handleChange}
            style={{ width: "80px" }}
          />

          <input
            type="text"
            name="nome"
            placeholder="Filtrar nome"
            value={filtros.nome}
            onChange={handleChange}
          />

          <select name="modalidade" value={filtros.modalidade} onChange={handleChange}>
            <option value="">modalidade</option>
            <option value="Presencial">Presencial</option>
            <option value="Híbrido">Híbrido</option>
            <option value="Live">Live</option>
            <option value="EAD">EAD</option>
            <option value="Outros">Outros</option>
          </select>

          {!["coordenador", "professor"].includes(tipoUsuario) && (
            <>
              <select name="nivel" value={filtros.nivel} onChange={handleChange}>
                <option value="">nível</option>
                <option value="Ensino Médio">Ensino Médio</option>
                <option value="Preparatório">Preparatório</option>
                <option value="Graduação/Pós">Graduação/Pós</option>
                <option value="PJ RH/T&D">PJ RH/T&D</option>
              </select>

              <select name="coordenador" value={filtros.coordenador} onChange={handleChange}>
                <option value="">coordenador</option>
                {coordenadores.map((c) => (
                  <option key={c.id} value={c.nome_completo}>
                    {c.nome_completo}
                  </option>
                ))}
              </select>
            </>
          )}
        </div>

        <div className="filtros-linha-2">
          <button className="btn btn-secondary" onClick={handleLimpar}>
            Limpar Filtros
          </button>

          {!["coordenador", "professor"].includes(tipoUsuario) && (
            <Link
              to="/cursos/cadastrar"
              className="btn btn-primary"
              style={{ textDecoration: "none" }}
            >
              Adicionar Curso
            </Link>
          )}
        </div>
      </div>

      <table className="tabela" style={{ borderRadius: "10px", fontSize: "0.75rem" }}>
        <thead
          style={{
            backgroundColor: parametros?.cor_cabecalho || "#156082",
            color: "white"
          }}
        >
          <tr>
            <th style={{ width: "15%", textAlign: "left" }}>Código</th>
            <th style={{ width: "35%", textAlign: "left" }}>Nome</th>
            <th style={{ width: "15%", textAlign: "left" }}>Nível</th>
            <th style={{ width: "15%", textAlign: "left" }}>Modalidade</th>
            <th style={{ width: "20%", textAlign: "left" }}>Coordenador</th>
          </tr>
        </thead>
        <tbody>
          {cursos.map((curso) => (
            <tr key={curso.id}>
              <td>{curso.codigo}</td>
              <td>
                <Link
                  to={`/detalhes-curso/${curso.id}`}
                  style={{
                    color: "#007bff",
                    textDecoration: "underline",
                    cursor: "pointer"
                  }}
                >
                  {curso.nome}
                </Link>
              </td>
              <td>{curso.nivel}</td>
              <td>{curso.modalidade}</td>
              <td>{curso.coordenador_nome}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ListagemCursos;
